import { hashMaterialProperties, ShadingMode, OutlineMode } from "flavr-common";
import { PRIMITIVE_MESH_INSTANCE_SHADER } from "./PrimitiveMeshInstanceShader";
import { BackSide } from "three";
import { createGeometryMaterial } from "./instance.shader";
import { CustomShaderMaterial } from "../../shader/CustomShaderMaterial";
export const MATERIALS_FOR_PRIMITIVE_MESHS = new Map();
export function getPrimitiveMeshMaterial(properties) {
    const hash = hashMaterialProperties(properties);
    let material = MATERIALS_FOR_PRIMITIVE_MESHS.get(hash);
    if (!material) {
        const defines = {
            USE_INSTANCE_COLOR: "",
            USE_INSTANCE_CLIP_FADE: ""
        };
        material = createGeometryMaterial(defines, PRIMITIVE_MESH_INSTANCE_SHADER.uniforms, properties, false);
        MATERIALS_FOR_PRIMITIVE_MESHS.set(hash, material);
    }
    return material;
}
export function getPrimitiveMeshReducedMaterial() {
    let material = MATERIALS_FOR_PRIMITIVE_MESHS.get("Reduced");
    if (!material) {
        const defines = {
            USE_INSTANCE_COLOR: "",
            MONOCHROME: ""
        };
        material = createGeometryMaterial(defines, PRIMITIVE_MESH_INSTANCE_SHADER.uniforms, {
            shading: ShadingMode.Phong,
            outline: OutlineMode.Straight
        }, false);
        MATERIALS_FOR_PRIMITIVE_MESHS.set("Reduced", material);
    }
    return material;
}
export function getPrimitiveMeshDepthMaterial() {
    let material = MATERIALS_FOR_PRIMITIVE_MESHS.get("Depth");
    if (!material) {
        material = new CustomShaderMaterial({
            vertexShader: PRIMITIVE_MESH_INSTANCE_SHADER.depthVertexShader,
            fragmentShader: PRIMITIVE_MESH_INSTANCE_SHADER.depthFragmentShader,
            uniforms: PRIMITIVE_MESH_INSTANCE_SHADER.uniforms,
            side: BackSide
        });
        MATERIALS_FOR_PRIMITIVE_MESHS.set("Depth", material);
    }
    return material;
}
